module.exports = __webpack_public_path__ + "static/media/fleche-gauche-cercle.fa209671.png";